import styled from 'styled-components';
import { UIStyledComponentProps } from '../../components/types';
import { getCssResponsive } from '../../components/utils';

type Props = {
};

export type FlexColProps = UIStyledComponentProps<Props>;

export const FlexCol = styled.div<FlexColProps>`
  display: flex;
  flex-direction: column;
  // align-items: flex-start;
  width: 100%;
  ${props => getCssResponsive(props)}
`;
